import {createSlice, createAsyncThunk, PayloadAction} from '@reduxjs/toolkit'
import axios from 'axios'
const api = '/api/'
export const companiesList = createAsyncThunk(
  'company/companies-list',
  async (params: any, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}school-company/list`, params)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const companyStore = createAsyncThunk(
  'company/company-store',
  async (companyData: any, thunkAPI) => {
    try {
      const {data} = await axios.post(`${api}school-company/store`, companyData)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors)
    }
  }
)

export const companyEdit = createAsyncThunk('company/company-edit', async (id: any, thunkAPI) => {
  try {
    const {data} = await axios.get(`${api}school-company/edit/${id}`)
    return data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data?.errors)
  }
})

export const companySwitchStatus = createAsyncThunk(
  'company/company-switch-status',
  async (id: any, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}school-company/switch-status/${id}`)
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data)
    }
  }
)

type CompanyState = {
  errors: any
}

const initialState: CompanyState = {
  errors: '',
}

export const companySlice = createSlice({
  name: 'dua-finance',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(companyStore.rejected, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
  },
})

export const {reset} = companySlice.actions
export default companySlice.reducer
